export default __webpack_public_path__ + "2e4bee9b9b2823c4b53259ce6214a926.png";